<template>
  <v-app id="app">
    <Nav v-if="!(this.$route.path == '/login' || this.$route.path == '/' || this.$route.path == '/register')" />
    <v-container
      style="padding:0px"
      fluid
      v-bind:class="{
        '': !(this.$route.path == '/login' || this.$route.path == '/' || this.$route.path == '/register'),
      }"
    >
      <router-view></router-view>
      <Style />
      <notifications />
    </v-container>
    <!-- <Map v-if="!(this.$route.path == '/login' || this.$route.path == '/' || this.$route.path == '/register')" /> -->
    <Footer v-if="!(this.$route.path == '/login' || this.$route.path == '/' || this.$route.path == '/register')" />
  </v-app>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Nav from '@/components/Nav.vue';
// import Map from '@/components/Map.vue';
import Style from '@/components/css/Style.css';

export default {
  name: 'App',
  data: () => ({
    SpeechRecognition: {},
    recognition: {},
  }),
  components: {
    Footer,
    Nav,
    // Map,
    Style
  },
  methods: {
  },
  mounted() {
    console.log('event');
    console.log();
    document.addEventListener('keydown', function(event) {
      if (event.keyCode === 192) {
        Event.$emit('speakModeOn');
        event.preventDefault();
      }
    });
  },
  created() {
  this.$store.dispatch('fetchUsersList');
},
};
</script>
<style>
/* .bg-content {
  background: #0c161bd8;
  padding: 0px;
  min-height: 90vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}
  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 150%;
  }
  
@media (max-width: 1000px) {
   .bg-content {
  background: #0c161bd8;
  padding: 0px;
  min-height: 90vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}
  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 150%;
  } 
} */
#virtual-scroll-table {
  max-height: 480px;
  overflow: auto;
}
@media only screen and (max-width: 600px) {
  #virtual-scroll-table {
    max-height: 550px;
    overflow: auto;
  }
}
#virtual-scroll-table-2 {
  max-height: 600px;
  overflow: auto;
}
#virtual-scroll-table-3 {
  max-height: 600px;
  overflow: auto;
}
#virtual-scroll-table-4 {
  max-height: 384px;
  overflow: auto;
  top: -10px;
}
#virtual-scroll-table-5 {
  max-height: 600px;
  overflow: auto;
}
.d-flex-row {
  display: flex;
  flex-direction: row;
}

.d-flex-col {
  display: flex;
  flex-direction: column;
}
.flex1 {
  flex: 1;
}
.btn {
  background: #bbd64d !important;
  color: #fff !important;
}
.mt2 {
  margin-top: 2rem;
}
.or-seprator {
  text-align: center;
  font-size: 13px;
  color: #6b6868;
}
.height100 {
  height: 100vh;
  overflow: hidden;
}
.route-content {
  overflow-y: scroll;
  height: 100vh;
}

/* .theme-bg-card {
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
  height: 400px;
}

.theme-bg-card:hover {
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #42da91;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.2), inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
  color: #efe;
  outline: 20px;
}
.theme-bg-card-2 {
  background: rgba(48, 64, 87, 0.6);
  outline-color: #5a80bf;
  color: #fff;
}

@media only screen and (max-width: 600px) {
  .theme-bg-card-2 {
    background: rgba(48, 64, 87, 0.6);
    outline-color: #5a80bf;
    color: #fff;
    top: 100px;
  }
}
.chart-content {
  background: rgba(12, 22, 27, 0.4);
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 0px;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
} */
</style>
